import moment from "moment";
export const dummyData = () => {
  const firstNames = [
    // Original names (no duplicates and corrected)
    "Maria",
    "João",
    "Ana",
    "Pedro",
    "Luísa",
    "Carlos",
    "Sofia",
    "Miguel",
    "Rita",
    "Tiago",
    "Inês",
    "Paulo",
    "Clara",
    "Joana",
    "Ricardo",
    "Helena",
    "Gustavo",
    "Beatriz",
    "André",
    "Laura",
    "Vasco",
    "Sara",
    "Francisco",
    "Matilde",
    "Duarte",
    "Lara",
    "Leonor",
    "Afonso",
    "Mariana",
    "Gabriel",
    "Isabel",
    "Bruno",
    "Catarina",
    "Filipe",
    "Raquel",
    "Nuno",
    "Cristina",
    "Hugo",
    "Patrícia",
    "Manuela",
    "Soraia",
    "Teresa",
    "Carla",
    "Marisa",
    "Filipa",
    "Maria João",
    "Carina",
    "Rosa",
    "Alberta",
    "Marta",
    "Tânia",
    "Madalena",
    "Elsa",
    "Célia",
    "Vera",
    "Lúcia",
    "Adriana",
    "Daniela",
    "Sílvia",
    "Fátima",
    "Graça",
    "Lígia",
    "Carmen",
    "Diana",
    "Sónia",
    "Ana Paula",
    "Elisabete",
    "Susana",
    "Julieta",
    "Olga",
    "Lena",
    "Nádia",
    "Mafalda",
    "Cátia",
    "Rute",
    "Vânia",
    "Vanessa",
    "Cíntia",
    "Mónica",
    "Ana Ramalho",
    // Additional common names in Portugal
    "Rui",
    "José",
    "António",
    "Luís",
    "Manuel",
    "Jorge",
    "Diogo",
    "Gonçalo",
    "Rodrigo",
    "Fernando",
    "Tomás",
    "Vítor",
    "Simão",
    "Rafael",
    "Daniel",
    "David",
    "Bernardo",
    "Samuel",
    "Martim",
    "Alexandre",
    "Fábio",
    "Joaquim",
    "Alberto",
    "Armando",
    "Henrique",
    "Alice",
    "Carolina",
    "Constança",
    "Eduarda",
    "Eva",
    "Francisca",
    "Gabriela",
    "Inês Maria",
    "Iara",
    "Júlia",
    "Lídia",
    "Lurdes",
    "Melissa",
    "Micaela",
    "Natália",
    "Paula",
    "Renata",
    "Salomé",
    "Sandra",
    "Tatiana",
    "Vitória",
    "Andreia",
  ];

  const lastNames = [
    // Original surnames (no duplicates)
    "Silva",
    "Santos",
    "Oliveira",
    "Souza",
    "Pereira",
    "Lima",
    "Costa",
    "Almeida",
    "Martins",
    "Gomes",
    "Ferreira",
    "Ribeiro",
    "Mendes",
    "Cardoso",
    "Teixeira",
    "Rocha",
    "Barbosa",
    "Correia",
    "Pinto",
    "Dias",
    "Moreira",
    "Castro",
    "Fonseca",
    "Carvalho",
    "Monteiro",
    "Nunes",
    "Azevedo",
    "Cunha",
    "Vieira",
    "Gonçalves",
    "Moura",
    "Faria",
    "Pires",
    "Cavalcante",
    "Campos",
    "Freitas",
    "Resende",
    "Batista",
    "Neves",
    "Cordeiro",
    "Barros",
    "Lopes",
    "Melo",
    "César",
    "Vasconcelos",
    "Siqueira",
    "Duarte",
    "Borges",
    "Figueiredo",
    "Simões",
    "Neto",
    "Lourenço",
    "Macedo",
    "Ramos",
    "Cabrera",
    "Brandão",
    "Tavares",
    "Guimarães",
    "Amaral",
    "Sampaio",
    "Carmo",
    "Barreto",
    "Lacerda",
    "Furtado",
    "Matos",
    "Coutinho",
    "Queiroz",
    "Viana",
    "Sá",
    "Dantas",
    "Feliciano",
    "Vaz",
    // Additional common surnames in Portugal
    "Rodrigues",
    "Soares",
    "Reis",
    "Miranda",
    "Sousa",
    "Coelho",
    "Maia",
    "Esteves",
    "Antunes",
    "Henriques",
    "Marques",
    "Pacheco",
    "Guerreiro",
    "Bento",
    "Leite",
    "Alves",
    "Fonseca",
    "Nogueira",
    "Araújo",
    "Magalhães",
    "Fernandes",
    "Gaspar",
    "Pedrosa",
    "Machado",
    "Sequeira",
    "Vicente",
    "Domingues",
    "Moreira",
    "Frade",
    "Baptista",
  ];
  const randomName = `${firstNames[Math.floor(Math.random() * firstNames.length)]} ${lastNames[Math.floor(Math.random() * lastNames.length)]}`;
  const randomNumber = Math.floor(Math.random() * 999);
  // 26-12-2025 (actual date)
  const dateString = moment().format("DD-MM-YYYY");

  const emailPartWithoutAccents = randomName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const randomEmail = `${emailPartWithoutAccents.toLowerCase().replace(/ /g, "-")}-${dateString}-${randomNumber}@salespark.io`;

  const randomPrefix = ["91", "92", "93", "96"][Math.floor(Math.random() * 4)];
  const randomDigits = Math.floor(Math.random() * 10000000)
    .toString()
    .padStart(7, "0");
  const randomPhone = `+351${randomPrefix}${randomDigits}`;

  return {
    name: randomName,
    email: randomEmail,
    phone: randomPhone,
  };
};
